(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('uploadFileConstants', {
            ASSET_FILE_DESTINATION: {
                FLYER: 'FLYER',
                HUB_FLYER: 'HUB_FLYER',
                SHOWCASE: 'SHOWCASE',
                HUB_SHOWCASE: 'HUB_SHOWCASE',
                PROFILE: 'PROFILE',
                PROFILE_BANNER: 'PROFILE_BANNER',
                PROFILE_BANNER_MOBILE: 'PROFILE_BANNER_MOBILE'
            }
        });
})();
